export default __webpack_public_path__ + "static/logo new-f11985a570eb0500d679fccca12b2931.png";